module.exports = __webpack_public_path__ + "static/media/print.efeb9b01.svg";